export const gtm1Checkout = {
  eventSplashScreenActionHandler ({ data }) {
    const {
      screenName,
      pageSource,
      eventAction,
      kycStatus,
      warningType,
    } = data

    return {
      event: 'Splash_Screen_Action',
      properties: {
        screen_name: screenName,
        page_source: pageSource,
        event_action: eventAction,
        kyc_status: kycStatus || null,
        warning_type: warningType || null,
      },
    }
  },

  eventCheckoutActionHandler ({ data }) {
    const {
      screenName,
      eventAction,
      customerDetails,
      customerPaymentsDetails,
      autopay,
      appointmentId,
      transactionId,
      checkoutFastCharge,
      entrancePath,
      paymentMethod,
      checkoutStatus,
    } = data

    return {
      event: 'Checkout_Action',
      properties: {
        screen_name: screenName,
        event_action: eventAction,
        customer_details: customerDetails,
        customer_payments_details: customerPaymentsDetails,
        autopay: autopay,
        appointment_id: appointmentId,
        transaction_id: transactionId,
        checkout_fast_charge: checkoutFastCharge,
        entrance_path: entrancePath,
        payment_method: paymentMethod,
        checkout_status: checkoutStatus,
      },
    }
  },
}
